// Perf: mark module start as early as possible
try { if (window && window.performance) { window.performance.mark('gt-main-exec-start'); } } catch (e) {}

import assets from 'Assets/js/modules/jsAssets';
import lazyloader from '@pernod-ricard-global-cms/cbllazyloader';
import mainMenuTwo from 'Assets/js/components/main-menu-two';
import personalisationOverlay from 'Assets/js/components/blocks/personalisation-overlay';
import productAside from 'Assets/js/components/blocks/product-aside';
import addToCart from 'Assets/js/components/add-to-cart';
import herohomepage from 'Assets/js/components/blocks/hero-homepage';
import maintenanceMode from 'Assets/js/components/maintenance-mode';
import globalTheme from 'Assets/js/components/globalTheme';
import promopopup from 'Assets/js/components/blocks/promopopup';

// Perf: long task observer (dev-mode guard inside callbacks)
let __gtLongTasks = [];
try {
  const supportsLongTask = typeof PerformanceObserver !== 'undefined' && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
  if (supportsLongTask) {
    const longTaskObserver = new PerformanceObserver((list) => {
      const dev = String((window.global_theme_object || {}).dev_mode || '') === 'true';
      list.getEntries().forEach((e) => {
        const attr = (e.attribution && e.attribution.length) ? e.attribution[0] : null;
        const entry = {
          startTime: e.startTime,
          duration: e.duration,
          startTime_s: Number((e.startTime/1000).toFixed(3)),
          duration_s: Number((e.duration/1000).toFixed(3)),
          attribution: attr ? {
            name: attr.name,
            entryType: attr.entryType,
            startTime: attr.startTime,
            duration: attr.duration,
            containerType: attr.containerType,
            containerName: attr.containerName,
            containerSrc: attr.containerSrc,
            containerId: attr.containerId,
            scriptUrl: attr.scriptURL || attr.scriptUrl || null
          } : null
        };
        __gtLongTasks.push(entry);
        if (dev) try { window.dispatchEvent(new CustomEvent('gt:longtask', { detail: entry })); } catch (_) {}
      });
    });
    longTaskObserver.observe({ entryTypes: ['longtask'] });
  }
} catch (_) {}

// Perf: helper to measure dynamic imports
function measureImport(label, importer){
  const dev = String((window.global_theme_object || {}).dev_mode || '') === 'true';
  const start = (window.performance && window.performance.now) ? window.performance.now() : 0;
  return importer().then((mod) => {
    const end = (window.performance && window.performance.now) ? window.performance.now() : start;
    const duration = end - start;
    const payload = { label, duration, duration_s: Number((duration/1000).toFixed(3)) };
    try {
      window.__gtImports = window.__gtImports || [];
      window.__gtImports.push(payload);
      if (dev) {
        try { console.log('[Perf] import', label, payload); } catch (_) {}
        try { window.dispatchEvent(new CustomEvent('gt:import-timing', { detail: payload })); } catch (_) {}
      }
    } catch (_) {}
    return mod;
  });
}

const t0 = performance.now();

const getJsUtils = () => import(/* webpackPrefetch: true */ '@pernod-ricard-global-cms/jsutils');
const getPersonalisationController = () => import(/* webpackPrefetch: true */ 'Assets/js/components/blocks/personalisation-controller');
const getUserLocale = () => import(/* webpackPrefetch: true */ 'Assets/js/components/user-locale');
const getEcrm = () => import(/* webpackPrefetch: true */ 'Assets/js/components/ecrm');
const getGenericPopup = () => import(/* webpackPrefetch: true */ 'Assets/js/components/generic-popup');
const getGtmTrigger = () => import(/* webpackPrefetch: true */ 'Assets/js/components/gtmTrigger');
const getGlobalTheme = () => import(/* webpackPreload: true */ 'Assets/js/components/globalTheme');
const getSiteHeaderJs = () => import(/* webpackPreload: true */ 'Assets/js/components/site-header');
const thirdPartLoader = () => import(/* webpackPrefetch: true */ 'Assets/js/components/thirdPartLoader');
const valentinesLoader = () => import(/* webpackPrefetch: true */ 'Assets/js/components/valentinesLoader');

const preCheckMarket = () => {
  // Pre-check immediately market
  if (
    window.global_theme_object &&
    (!window.global_theme_object.markets.markets ||
      !window.global_theme_object.markets.markets[
        window.global_theme_object.user_local
      ])
  ) {
    // Invalid market. Fall back to the default market without forcing a reload loop.
    const locale = 'EUR - Ireland';

    window.global_theme_object.user_local = locale;
    document.cookie = `STYXKEY_locale=${locale}; path=/`;
  }

  return true;
};




measureImport('site-header', getSiteHeaderJs)
  .then((module) => {
    const t1 = performance.now();
    console.log(`getSiteHeaderJs took ${Math.round(t1 - t0)} ms`);
    module.default();
  })
  .catch((error) => {
    // eslint-disable-next-line no-console
    console.error('Error loading site header', error);
  });

// eslint-disable-next-line func-names
window.onerror = function (error, url, line) {
  // eslint-disable-next-line no-console
  console.warn('Error happened');
  // eslint-disable-next-line no-console
  console.warn(error, url, line);
};

import('Assets/scss/generic/used-icons.scss');

window.addEventListener('DOMContentLoaded', () => {
  // Pre-check immediately market
  if (!preCheckMarket()) {
    return;
  }

  mainMenuTwo();

  // Feature flag: optionally defer non-critical modules to idle
  const FE = (window.global_theme_object || {}).feature_enabled || {};
  const deferOptional = FE.defer_optional_modules === true;
  const ric = window.requestIdleCallback || function(cb){ setTimeout(() => cb({ timeRemaining: () => 0 }), 500); };
  const optionalImport = (label, importer, initFn, onErrLabel) => {
    const run = () => measureImport(label, importer)
      .then((mod) => { try { initFn(mod); } catch (e) { try { console.error(`Error initialising ${onErrLabel||label}`, e); } catch(_) {} } })
      .catch((error) => { try { console.error(`Error loading ${onErrLabel||label}`, error); } catch(_) {} });
    if (deferOptional) ric(run); else run();
  };

  lazyloader.options.assetArray = assets.dynamicAssets;
  lazyloader.options.debugLogMessages = false;
  lazyloader.options.filePath = 'js/components/blocks/';
  lazyloader.lazyloaderInit();

  // Load immediately hero homepage
  herohomepage();

  // Load immediately maintenance mode, if enabled
  maintenanceMode();

  // [Lighthouse]
  // Warning about LCP elements. See https://web.dev/articles/lcp-lazy-loading
  new PerformanceObserver((list) => {
    const latestEntry = list.getEntries().at(-1);

    if (latestEntry?.element?.getAttribute('loading') === 'lazy') {
      // eslint-disable-next-line no-console
      console.warn('Warning: LCP element was lazy loaded', latestEntry);
    }
  }).observe({ type: 'largest-contentful-paint', buffered: true });

  measureImport('jsutils', getJsUtils)
    .then((jsUtils) => {
      jsUtils.default.checkDevice();
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error loading JS utils', error);
    });

  if (document.getElementById('productaside')) {
    const start = performance.now();
    productAside();
    try {
      const end = performance.now();
      const payload = {
        label: 'product-aside',
        duration: end - start,
        duration_s: Number(((end - start) / 1000).toFixed(3))
      };
      window.__gtImports = window.__gtImports || [];
      window.__gtImports.push(payload);
    } catch (_) {}
  }

  addToCart();

  optionalImport(
    'personalisation-controller',
    getPersonalisationController,
    (module) => { module.default(); }
  );

  optionalImport(
    'user-locale',
    getUserLocale,
    (module) => { module.default(); }
  );

  // Generic popup (optional)
  optionalImport('generic-popup', getGenericPopup, (module) => { module.default(); });

  measureImport('globalTheme', getGlobalTheme)
    .then(() => {
      if (globalTheme.featureEnabled().promo_popups === true) {
        promopopup();
        // Test promo: trigger popup via query param ?test_promo=<ID>
        try {
          const params = new URLSearchParams(window.location.search || '');
          const testId = params.get('test_promo');
          if (testId) {
            const promotionDetails = globalTheme.promotionDetails() || {};
            const details = promotionDetails[testId];
            if (details) {
              // Defer a tick to ensure Vue promo component is mounted
              setTimeout(() => {
                window.dispatchEvent(new CustomEvent('promo-toggled', {
                  detail: { promoId: String(testId), promoDetails: details }
                }));
              }, 200);
            }
          }
        } catch (e) {
          try { console.error('Test promo dispatch failed', e); } catch(_) {}
        }
      }
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error loading promo popup', error);
    });

  // GTM (optional)
  optionalImport('gtmTrigger', getGtmTrigger, (module) => { module.default(); }, 'GTM');

  // Feature-driven modules
  if (
    window.global_theme_object &&
    window.global_theme_object.feature_enabled
  ) {
    // Create global ECRM object and initialise it
    if (window.global_theme_object.feature_enabled.ecrm_tracking === true) {
      optionalImport('ecrm', getEcrm, (module) => { module.default().pageView(); }, 'ECRM');
    }

    // Initialise third part loader (optional)
    optionalImport('thirdPartLoader', thirdPartLoader, (module) => { module.default(); }, 'third parts');
  }

  // Valentines loader (behind feature flag; off by default)
  if (FE.valentines_loader === true) {
    optionalImport('valentinesLoader', valentinesLoader, (module) => { module.default(); }, 'Valentines');
  }

  // App height
  const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--screen-height', `${window.innerHeight}px`);
  };
  window.addEventListener('resize', appHeight);
  appHeight();
  // Observe key data-ready events from globalTheme shims
  const dev = String((window.global_theme_object || {}).dev_mode || '') === 'true';
  const addReady = (evtName, label) => {
    try {
      window.addEventListener(evtName, () => {
        if (!window.performance) return;
        const now = window.performance.now();
        const entry = { label, ts_ms: now, ts_s: Number((now/1000).toFixed(3)) };
        window.__gtDataReady = window.__gtDataReady || [];
        window.__gtDataReady.push(entry);
        if (dev) {
          try { console.log('[Perf] data ready', entry); } catch (_) {}
          try { window.dispatchEvent(new CustomEvent('gt:data-ready', { detail: entry })); } catch (_) {}
        }
      });
    } catch(_){}
  };
  addReady('products-ready', 'products-ready');
  addReady('oss:product-prices-loaded', 'product-prices-loaded');
  addReady('oss:vat-loaded', 'vat-loaded');
  addReady('oss:shipping-loaded', 'shipping-loaded');
});

window.onload = () => {
  const domDev = String((window.global_theme_object || {}).dev_mode || '') === 'true';
  try { if (window.performance) window.performance.mark('gt-main-onload-start'); } catch (_) {}
  personalisationOverlay();
  if (globalTheme.featureEnabled().show_version === true) {
    // eslint-disable-next-line no-console
    console.info(
      `%cCurrent OSS version: ${window.global_theme_object.version}`,
      'color: orange; font-weight: bold;'
    );
  }

  globalTheme.geoLocation().then(() => {
    if (
      sessionStorage.getItem('geoLocation') === 'US' &&
      !sessionStorage.getItem('geoRedirectChoice')
    ) {
      window.dispatchEvent(
        new CustomEvent('error-toggled', {
          detail: {
            title: 'Looks like you are visiting from the United States',
            content:
              'Visit our US online store to shop official Jameson Merch delivered direct to your home from ours.',
            buttons: [
              {
                label: '<u>No</u><br/>Stay on current shop',
                callback: () => {
                  sessionStorage.setItem('geoRedirectChoice', 'stay');
                }
              },
              {
                label: '<u>Yes</u><br/>Shop Merch',
                class: 'btn-alt',
                callback: () => {
                  sessionStorage.setItem('geoRedirectChoice', 'leave');
                  window.location.replace('https://shopjamesonus.com/');
                }
              }
            ]
          }
        })
      );
    }
  });
  // After onload handler completes, summarise perf
  try {
    if (window.performance) {
      window.performance.mark('gt-main-onload-end');
      try { window.performance.measure('gt-main-exec', 'gt-main-exec-start', 'gt-main-onload-end'); } catch (_) {}
      const m = window.performance.getEntriesByName('gt-main-exec').slice(-1)[0];
      // Summarise long tasks up to now
      const longTasks = (__gtLongTasks || []);
      const longSummary = longTasks.reduce((acc, e) => {
        acc.count += 1; acc.sum += e.duration; acc.max = Math.max(acc.max, e.duration); return acc;
      }, { count: 0, sum: 0, max: 0 });
      const deep = {
        module_exec_ms: m ? m.duration : null,
        module_exec_s: m ? Number((m.duration/1000).toFixed(3)) : null,
        longtasks_count: longSummary.count,
        longtasks_sum_ms: longSummary.sum,
        longtasks_sum_s: Number((longSummary.sum/1000).toFixed(3)),
        longtasks_max_ms: longSummary.max,
        longtasks_max_s: Number((longSummary.max/1000).toFixed(3)),
        imports: (window.__gtImports || [])
      };
      if (domDev) {
        try { console.log('[Perf] deep metrics', deep); } catch (_) {}
        try { window.dispatchEvent(new CustomEvent('gt:main-js-deep-metrics', { detail: deep })); } catch (_) {}
      }
    }
  } catch (_) {}
};

// Perf: mark module end (top-level sync complete)
try { if (window && window.performance) { window.performance.mark('gt-main-exec-sync-end'); } } catch (e) {}
